export const validateIncompleteLanguageObject = (obj: any, languages: Array<string>, message: string)  => {
    if (obj == undefined) {
        return message;
    }

    const keys = Object.keys(obj);
    if (keys.length == 0) {
        return message;
    }

    let allValid = true;
    for (const language of languages) {
        if (obj[language] == undefined || obj[language] == '') {
            allValid = false;
            break;
        }
    }

    if (!allValid) {
        return message;
    }

    return undefined;
}


// WEBPACK FOOTER //
// ./src/helpers/Validations/validateIncompleteLanguageObject.ts